import React from 'react';
import { Button } from '../../ui/Button';
import { FileUpload } from '../../ui/FileUpload';
interface RegistrationDocumentScreenProps {
  registrationDocument: File | null;
  onChange: (file: File | null) => void;
  onNext: () => void;
  onBack: () => void;
}
export function RegistrationDocumentScreen({
  registrationDocument,
  onChange,
  onNext,
  onBack
}: RegistrationDocumentScreenProps) {
  const isValid = registrationDocument !== null;
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-289">
      <div className="flex-1" data-id="element-290">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-291">
          Registration Document
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-292">
          Please upload your official business registration certificate.
        </p>

        <div className="space-y-6" data-id="element-293">
          <FileUpload label="Certificate of Incorporation / Business Registration" value={registrationDocument} onChange={onChange} accept=".pdf,.jpg,.jpeg,.png" data-id="element-294" />
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-295">
            <p className="text-sm text-blue-700" data-id="element-296">
              Ensure the document clearly shows the business name and
              registration number.
            </p>
          </div>
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-297">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-298">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-299">
          Continue
        </Button>
      </div>
    </div>;
}